module.exports = __webpack_public_path__ + "img/menuIcon32.3a478f5f.png";